import { AnyAction } from 'redux';
import { DraftDesignConfiguration } from '@/types';
import { getMaskedDesignPreview } from '@/utils/masks/getMaskedDesignPreview';
import { setImageObjectUrl } from '@/utils/upload/imageObjectUrls';
import { getConfigurationFilterId } from '@/features/filters/getConfigurationFilterId';
import { assertPixelDesign } from '@/model/design/isDesignType';
import { Thunk } from '@/redux/types';
import { removeFilterAction } from '@/components/draft/draftState/actions/removeFilterAction';
import { getDesignByConfigurationId } from '../getters/getDesignByConfigurationId';

export const removeConfigurationFilterAction =
  (configuration: DraftDesignConfiguration): Thunk<void, AnyAction> =>
  async (dispatch, getState) => {
    const { cid, mask } = configuration;

    setImageObjectUrl(getConfigurationFilterId(cid), '');

    if (mask) {
      await getMaskedDesignPreview(
        mask,
        cid,
        assertPixelDesign(getDesignByConfigurationId(getState(), cid)),
        mask.scale,
        mask.offset
      );
    }

    getState().draftDispatch(removeFilterAction(configuration));
  };
